// components/Tabs.tsx
import { useState, ReactNode } from "react";

export const Tab = ({
                        labels,
                        children,
                    }: {
    labels: string[];
    children: ReactNode[];
}) => {
    const [activeIndex, setActiveIndex] = useState(0);

    // Drop conditionally-omitted panels (false/null from `{cond && <div>…</div>}`)
    // so panel indexes stay aligned with the labels array. Without this, a
    // hidden tab's `false` child would occupy a slot and every later tab would
    // show the previous tab's panel.
    const panels = (Array.isArray(children) ? children : [children]).filter(
        Boolean
    );

    return (
        <div>
            <div className="flex flex-wrap border-b border-gray-300">
                {labels.map((label, index) => (
                    <button
                        key={index}
                        type="button"
                        className={`w-1/2 sm:w-auto px-4 py-2 -mb-px text-sm font-medium rounded-t text-center ${
                            index === activeIndex
                                ? "bg-gray-100 border-t border-l border-r border-gray-300 text-gray-900"
                                : "bg-white text-gray-500 hover:text-gray-700 border border-gray-300"
                        }`}
                        onClick={() => setActiveIndex(index)}
                    >
                        {label}
                    </button>
                ))}
            </div>

            {/* Render all children, toggle visibility with Tailwind classes */}
            <div className="border border-gray-300 border-t-0 rounded-b bg-gray-100 p-4">
                {panels.map((child, index) => (
                    <div key={index} className={index === activeIndex ? "block" : "hidden"}>
                        {child}
                    </div>
                ))}
            </div>
        </div>
    );
};
